// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");

var $ = require("./lib/qsa");

var filterNav = $.one("nav.filters");

var rows = $(".listings tbody tr");
rows = rows.map(function(r) {
  return {
    element: r,
    genre: r.getAttribute("data-genre").split(";"),
    date: r.getAttribute("data-date")
  };
});

var intersect = function(a, b) {
  for (var i = 0; i < a.length; i++) {
    for (var j = 0; j < b.length; j++) {
      if (a[i] == b[j]) return true;
    }
  }
};

filterNav.addEventListener("change", function() {
  var dates = $(`[name="date-filter"]:checked`).map(e => e.value);
  var genres = $(`[name="genre-filter"]:checked`).map(e => e.value);

  rows.forEach(function(item) {
    var matched = true;
    if (dates.length && dates.indexOf(item.date) == -1) matched = false;
    if (genres.length && !intersect(genres, item.genre)) matched = false;

    item.element.classList[matched ? "remove" : "add"]("hidden");
  });
});